<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold">
            Mengubah Kategori
          </div>

          <v-card 
            flat
            class="mt-0"
            height="calc(100vh - 245px)"
            style="background: transparent;">
            <v-card-text class="px-0">

              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider
                        name="Nama Kategori Pegawai" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-15 label-input mb-2">
                          Nama Kategori Pegawai
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          solo

                          :color="set_color"
                          placeholder="Contoh. Admin"

                          
                          :item-color="set_color"

                          v-model="form.title"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <div>
                    <div class="fs-15 label-input mb-2">
                      Hak Akses
                    </div>

                    <div
                      style="height: calc(100vh - 470px); overflow-y: auto;">
                      <v-treeview
                        dense
                        open-all
                        open-on-click

                        selectable
                        :selected-color="set_color"

                        rounded
                        transition

                        :items="list"
                        item-key="id"
                        item-text="title"

                        item-children="sub_menu"
                        
                        return-object
                        class="non_border_tree"
                        
                        v-model="form.menu_arr">
                        <template v-slot:prepend="{ item }">
                          <v-img v-if="item.icon_color !== undefined"
                            width="20"
                            height="20"
                            alt="kominfoklaten"  
                            :src="item.icon_color"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="18"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>

                          <v-icon v-else
                            size="18">
                            mdi-minus-thick
                          </v-icon>
                        </template>
                      </v-treeview>
                    </div>
                  </div>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>


          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
              
              <v-btn
                to="/user/category"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Batal
              </v-btn>
            </v-col>
          </v-row>

          <!-- <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
            </v-col>
          </v-row> -->
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },

        role: [
          {
            id: 1,
            name: 'Admin'
          },
          {
            id: 2,
            name: 'Pegawai' 
          }
        ],
        list:[

        {
                      id: 122,
                      title: 'Dashboard',
                      icon: require('@/assets/icon/dashboard.png'),
                      icon_color: require('@/assets/icon/dashboard.png'),
                      link: '/dashboard',
                      active: false,
                      sub_menu: [],
                    },
        { 
                      id: 1,
                      title: 'User',
                      icon: require('@/assets/icon/profile.png'),
                      icon_color: require('@/assets/icon/profile-color.png'),
                      link: '/user',
                      active: false,
                      sub_menu: [
                        {
                          id: 2,
                          title: 'Staff',
                          link: '/user/staff',
                          icon: require('@/assets/icon/profile.png'),
                          icon_color: require('@/assets/icon/profile-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 3,
                          title: 'Supplier',
                          link: '/user/supplier',
                          icon: require('@/assets/icon/profile.png'),
                          icon_color: require('@/assets/icon/profile-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 4,
                          title: 'Kategori Staff',
                          link: '/user/category',
                          icon: require('@/assets/icon/profile.png'),
                          icon_color: require('@/assets/icon/profile-color.png'),
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                      id: 10,
                      title: 'Sales',
                      icon: require('@/assets/icon/sales-manager.png'),
                      icon_color: require('@/assets/icon/sales-manager-color.png'),
                      link: '/sales',
                      active: false,
                      sub_menu: [
                        {
                          id: 11,
                          title: 'sales',
                          link: '/sales/staff',
                          icon: require('@/assets/icon/sales-manager.png'),
                          icon_color: require('@/assets/icon/sales-manager-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 12,
                          title: 'Kode Sales (Area Sales)',
                          link: '/sales/code',
                          icon: require('@/assets/icon/sales-manager.png'),
                          icon_color: require('@/assets/icon/sales-manager-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        // {
                        //   id: 13,
                        //   title: 'Target Sales',
                        //   link: '/sales/target',
                        //   icon: require('@/assets/icon/salesGrey.png'),
                        //   icon_color: require('@/assets/icon/salesBlack.png'),
                        //   active: false,
                        //   sub_menu: [],
                        // }
                      ],
                    },
                    {
                      id: 6,
                      title: 'Customer',
                      icon: require('@/assets/icon/target.png'),
                      icon_color: require('@/assets/icon/target-color.png'),
                      link: '/customer/data',
                      active: false,
                      sub_menu: [
                      {
                          id: 7,
                          title: 'Customer Saya',
                          link: '/customer/data',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 59,
                          title: 'Pengajuan Customer',
                          link: '/customer/proses',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        // {
                        //   id: 60,
                        //   title: 'Proses Pengajuan',
                        //   link: '/customer/acc',
                        //   icon: require('@/assets/icon/target.png'),
                        //   icon_color: require('@/assets/icon/target-color.png'),
                        //   active: false,
                        //   sub_menu: [],
                        // },
                        {
                          id: 61,
                          title: 'Histori Rejected',
                          link: '/customer/reject',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 81,
                          title: 'Customer Blacklist',
                          link: '/customer/blacklist',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        // {
                        //   id: 8,
                        //   title: 'Toko',
                        //   link: '/customer/toko',
                        //   active: false,
                        //   sub_menu: [],
                        // },
                        {
                          id: 8,
                          title: 'Perubahan Plafon',
                          link: '/customer/plafon',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 9,
                          title: 'Perubahan Customer',
                          link: '/customer/perubahan',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 84,
                          title: 'Customer Mapping',
                          link: '/customer/mapping',
                          icon: require('@/assets/icon/target.png'),
                          icon_color: require('@/assets/icon/target-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                      ],
                    },
                    {
                      id: 85,
                      title: 'Live Tracking',
                      icon: require('@/assets/icon/shipment-tracking.png'),
                      icon_color: require('@/assets/icon/shipment-tracking-color.png'),
                      link: '/tracking',
                      active: false,
                      sub_menu: [
                        {
                          id: 86,
                          title: 'live Sales',
                          link: '/tracking/sales',
                          icon: require('@/assets/icon/shipment-tracking.png'),
                          icon_color: require('@/assets/icon/shipment-tracking-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 87,
                          title: '⁠Live Driver',
                          link: '/tracking/driver',
                          icon: require('@/assets/icon/shipment-tracking.png'),
                          icon_color: require('@/assets/icon/shipment-tracking-color.png'),
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                      id: 14,
                      title: 'Produk',
                      icon: require('@/assets/icon/dairy-products.png'),
                      icon_color: require('@/assets/icon/dairy-products-color.png'),
                      link: '/product',
                      active: false,
                      sub_menu: [
                        {
                          id: 15,
                          title: 'Data Produk',
                          link: '/product/data',
                          icon: require('@/assets/icon/dairy-products.png'),
                          icon_color: require('@/assets/icon/dairy-products-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 16,
                          title: 'Varian Produk',
                          link: '/product/varian',
                          icon: require('@/assets/icon/dairy-products.png'),
                          icon_color: require('@/assets/icon/dairy-products-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 17,
                          title: 'Kategori Produk',
                          link: '/product/category_product',
                          icon: require('@/assets/icon/dairy-products.png'),
                          icon_color: require('@/assets/icon/dairy-products-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 18,
                          title: 'Group Produk',
                          link: '/product/group',
                          icon: require('@/assets/icon/dairy-products.png'),
                          icon_color: require('@/assets/icon/dairy-products-color.png'),
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                  {
                    id: 41,
                    title: 'Stok',
                    icon: require('@/assets/icon/in-stock.png'),
                    icon_color: require('@/assets/icon/in-stock-color.png'),
                    link: '/stok',
                    active: false,
                    sub_menu: [
                      {
                        id: 42,
                        title: 'Stok',
                        link: '/stok/data',
                        icon: require('@/assets/icon/in-stock.png'),
                        icon_color: require('@/assets/icon/in-stock-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 43,
                      //   title: 'Stok In Order',
                      //   link: '/stok/in-order',
                      //   icon: require('@/assets/icon/in-stock.png'),
                      //   icon_color: require('@/assets/icon/in-stock-color.png'),
                      //   active: false,
                      //   sub_menu: [],
                      // },
                      {
                        id: 90,
                        title: 'Penyesuaian Stok',
                        link: '/stok/penyesuaian-stock',
                        icon: require('@/assets/icon/in-stock.png'),
                        icon_color: require('@/assets/icon/in-stock-color.png'),
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },
                    {
                      id: 22,
                      title: 'Kelola Visit',
                      icon: require('@/assets/icon/visitor.png'),
                      icon_color: require('@/assets/icon/visitor-color.png'),
                      link: '/visit',
                      active: false,
                      sub_menu: [
                        // {
                        //   id: 23,
                        //   title: 'Laporan Visit',
                        //   link: '/visit/laporan',
                        //   icon: require('@/assets/icon/visitor.png'),
                        //   icon_color: require('@/assets/icon/visitor-color.png'),
                        //   active: false,
                        //   sub_menu: [],
                        // },
                        {
                          id: 78,
                          title: 'Laporan Visit',
                          link: '/visit/laporan',
                          icon: require('@/assets/icon/visitor.png'),
                          icon_color: require('@/assets/icon/visitor-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 24,
                          title: 'Buat Jadwal Visit',
                          link: '/visit/jadwal',
                          icon: require('@/assets/icon/visitor.png'),
                          icon_color: require('@/assets/icon/visitor-color.png'),
                          active: false,
                          sub_menu: [],
                        },

                        {
                          id: 83,
                          title: 'Pergantian Jadwal',
                          link: '/visit/jadwal-change',
                          icon: require('@/assets/icon/visitor.png'),
                          icon_color: require('@/assets/icon/visitor-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                      ],
                    },
                    {
                      id: 111,
                      title: 'Laporan Visit Driver',
                      icon: require('@/assets/icon/route.png'),
                      icon_color: require('@/assets/icon/route.png'),
                      link: '/laporan-visit-driver',
                      active: false,
                      sub_menu: [],
                    },
                    {
                      id: 25,
                      title: 'Presensi',
                      icon: require('@/assets/icon/absent.png'),
                      icon_color: require('@/assets/icon/absent-color.png'),
                      link: '/presensi',
                      active: false,
                      sub_menu: [
                        {
                          id: 26,
                          title: 'Laporan Presensi',
                          link: '/presensi/data',
                          icon: require('@/assets/icon/absent.png'),
                          icon_color: require('@/assets/icon/absent-color.png'),
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 27,
                          title: 'Laporan Ijin',
                          link: '/presensi/ijin',
                          icon: require('@/assets/icon/absent.png'),
                          icon_color: require('@/assets/icon/absent-color.png'),
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                    id: 28,
                    title: 'Pembelian',
                    icon: require('@/assets/icon/cash-on-delivery.png'),
                    icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                    link: '/pengajuan',
                    active: false,
                    sub_menu: [
                      {
                        id: 29,
                        title: 'Permintaan Stok',
                        link: '/pengajuan/pembelian-warehouse',
                        icon: require('@/assets/icon/cash-on-delivery.png'),
                        icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 64,
                      //   title: 'Permintaan Barang',
                      //   link: '/pengajuan/permintaan-barang',
                      //   icon: require('@/assets/icon/cash-on-delivery.png'),
                      //   icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                      //   active: false,
                      //   sub_menu: [],
                      // },
                      {
                        id: 30,
                        title: 'Permintaan GM',
                        link: '/pengajuan/pembelian-general-manager',
                        icon: require('@/assets/icon/cash-on-delivery.png'),
                        icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 31,
                        title: 'Penerimaan Stok',
                        link: '/pengajuan/penerimaan/data',
                        icon: require('@/assets/icon/cash-on-delivery.png'),
                        icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 32,
                        title: 'QC Barang',
                        link: '/pengajuan/qc',
                        icon: require('@/assets/icon/cash-on-delivery.png'),
                        icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },
                  {
                    id: 44,
                    title: 'Order',
                    icon: require('@/assets/icon/order.png'),
                    icon_color: require('@/assets/icon/order-color.png'),
                    link: '/approval',
                    active: false,
                    sub_menu: [
                    {
                        id: 45,
                        title: 'Approval Order',
                        link: '/approval/order',
                        icon: require('@/assets/icon/order.png'),
                        icon_color: require('@/assets/icon/order-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 46,
                        title: 'Approval Order Warehouse',
                        link: '/approval/order-warehouse',
                        icon: require('@/assets/icon/order.png'),
                        icon_color: require('@/assets/icon/order-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 88,
                        title: 'Tracking Order',
                        link: '/approval/order-tracking',
                        icon: require('@/assets/icon/order.png'),
                        icon_color: require('@/assets/icon/order-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                    ],
                  },

                  // {
                  //   id: 65,
                  //   title: 'Pengajuan Barang',
                  //   icon: require('@/assets/icon/cabangGrey.png'),
                  //   icon_color: require('@/assets/icon/cabangBlack.png'),
                  //   link: '/pengajuan-barang',
                  //   active: false,
                  //   sub_menu: [
                  //   {
                  //       id: 66,
                  //       title: 'Data Pengajuan',
                  //       link: '/pengajuan-barang/data',
                  //       icon: require('@/assets/icon/cabangGrey.png'),
                  //       icon_color: require('@/assets/icon/cabangBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //   {
                  //       id: 67,
                  //       title: 'Approval Atasan',
                  //       link: '/pengajuan-barang/approval-atasan',
                  //       icon: require('@/assets/icon/cabangGrey.png'),
                  //       icon_color: require('@/assets/icon/cabangBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 68,
                  //       title: 'Approval General Manager',
                  //       link: '/pengajuan-barang/approval-general-manager',
                  //       icon: require('@/assets/icon/cabangGrey.png'),
                  //       icon_color: require('@/assets/icon/cabangBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 69,
                  //       title: 'Penerimaan Barang',
                  //       link: '/pengajuan-barang/approval-gudang',
                  //       icon: require('@/assets/icon/cabangGrey.png'),
                  //       icon_color: require('@/assets/icon/cabangBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 73,
                  //       title: 'Update harga & Pilih Supplier',
                  //       link: '/pengajuan-barang/update-harga-supplier',
                  //       icon: require('@/assets/icon/cabangGrey.png'),
                  //       icon_color: require('@/assets/icon/cabangBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     }
                  //   ],
                  // },

                  // {
                  //   id: 70,
                  //   title: 'Pembayaran Barang',
                  //   icon: require('@/assets/icon/productGrey.png'),
                  //   icon_color: require('@/assets/icon/productBlack.png'),
                  //   link: '/pembayaran-barang',
                  //   active: false,
                  //   sub_menu: [
                  //     {
                  //       id: 71,
                  //       title: 'Kasir',
                  //       link: '/pembayaran-barang/kasir',
                  //       icon: require('@/assets/icon/userGrey.png'),
                  //       icon_color: require('@/assets/icon/userBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 72,
                  //       title: 'Akunting',
                  //       link: '/pembayaran-barang/akunting',
                  //       icon: require('@/assets/icon/userGrey.png'),
                  //       icon_color: require('@/assets/icon/userBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 74,
                  //       title: 'Approval Finance Manager',
                  //       link: '/pembayaran-barang/manager-keuangan',
                  //       icon: require('@/assets/icon/userGrey.png'),
                  //       icon_color: require('@/assets/icon/userBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 75,
                  //       title: 'Approval General Manager',
                  //       link: '/pembayaran-barang/general-manager',
                  //       icon: require('@/assets/icon/userGrey.png'),
                  //       icon_color: require('@/assets/icon/userBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 76,
                  //       title: 'Print Kasir',
                  //       link: '/pembayaran-barang/print-kasir',
                  //       icon: require('@/assets/icon/userGrey.png'),
                  //       icon_color: require('@/assets/icon/userBlack.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     }
                  //   ]
                  // },

                  {
                    id: 48,
                    title: 'Pengiriman ',
                    icon: require('@/assets/icon/fast-delivery.png'),
                    icon_color: require('@/assets/icon/fast-delivery-color.png'),
                    link: '/delivery',
                    active: false,
                    sub_menu: [
                    {
                        id: 49,
                        title: 'Buat BPB',
                        link: '/delivery/bpb',
                        icon: require('@/assets/icon/fast-delivery.png'),
                        icon_color: require('@/assets/icon/fast-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 50,
                        title: 'Buat Surat Jalan',
                        link: '/delivery/surat-jalan',
                        icon: require('@/assets/icon/fast-delivery.png'),
                        icon_color: require('@/assets/icon/fast-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 77,
                        title: 'Proses Muat',
                        link: '/delivery/proses-muat',
                        icon: require('@/assets/icon/fast-delivery.png'),
                        icon_color: require('@/assets/icon/fast-delivery-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 51,
                        title: 'Konfirmasi Pengiriman',
                        icon: require('@/assets/icon/fast-delivery.png'),
                        icon_color: require('@/assets/icon/fast-delivery-color.png'),
                        link: '/konfirmasi-pengirirman',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 91,
                        title: 'Reschedule BPB',
                        icon: require('@/assets/icon/fast-delivery.png'),
                        icon_color: require('@/assets/icon/fast-delivery-color.png'),
                        link: '/delivery/reschedule',
                        active: false,
                        sub_menu: [],
                      },
                  {
                      id: 58,
                      title: 'Retur',
                      icon: require('@/assets/icon/fast-delivery.png'),
                      icon_color: require('@/assets/icon/fast-delivery-color.png'),
                      link: '/retur',
                      active: false,
                      sub_menu: [], 
                    },
                    ],
                  },


                  {
                    id: 52,
                    title: 'Promo',
                    icon: require('@/assets/icon/promo.png'),
                    icon_color: require('@/assets/icon/promo-color.png'),
                    link: '/promo',
                    active: false,
                    sub_menu: [
                    {
                        id: 53,
                        title: 'Data Promo',
                        link: '/promo/data',
                        icon: require('@/assets/icon/promo.png'),
                        icon_color: require('@/assets/icon/promo-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 54,
                        title: 'Banner',
                        link: '/promo/banner',
                        icon: require('@/assets/icon/promo.png'),
                        icon_color: require('@/assets/icon/promo-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 100,
                        title: 'Strata Harga',
                        icon: require('@/assets/icon/promo.png'),
                        icon_color: require('@/assets/icon/promo-color.png'),
                        link: '/promo/strata-harga',
                        active: false,
                        sub_menu: [],
                      },
                    ],
                  },
                  {
                    id: 33,
                    title: 'Finance',
                    icon: require('@/assets/icon/report.png'),
                    icon_color: require('@/assets/icon/report-color.png'),
                    link: '/finance',
                    active: false,
                    sub_menu: [
                    {
                        id: 34,
                        title: 'Data Penerimaan Stok',
                        link: '/finance/penerimaan/data',
                        icon: require('@/assets/icon/report.png'),
                        icon_color: require('@/assets/icon/report-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 35,
                        title: 'Close PO',
                        link: '/finance/po/data',
                        icon: require('@/assets/icon/report.png'),
                        icon_color: require('@/assets/icon/report-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 36,
                      //   title: 'Bank',
                      //   link: '/finance/bank',
                      //   icon: require('@/assets/icon/report.png'),
                      //   icon_color: require('@/assets/icon/report-color.png'),
                      //   active: false,
                      //   sub_menu: [],
                      // },
                      {
                        id: 36,
                        title: 'Invoice Supplier',
                        link: '/finance/invoice-supplier',
                        icon: require('@/assets/icon/report.png'),
                        icon_color: require('@/assets/icon/report-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 37,
                        title: 'Invoice Customer',
                        link: '/finance/invoice',
                        icon: require('@/assets/icon/report.png'),
                        icon_color: require('@/assets/icon/report-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 82,
                        title: 'Laporan Piutang',
                        link: '/finance/laporan-faktur',
                        icon: require('@/assets/icon/report.png'),
                        icon_color: require('@/assets/icon/report-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 62,
                      //   title: 'Approval Permintaan Barang',
                      //   link: '/finance/pengajuan',
                      //   icon: require('@/assets/icon/productGrey.png'),
                      //   icon_color: require('@/assets/icon/productBlack.png'),
                      //   active: false,
                      //   sub_menu: [],
                      // }
                    ],
                  },
                  {
                    id: 38,
                    title: 'Kasir',
                    icon: require('@/assets/icon/cashier.png'),
                    icon_color: require('@/assets/icon/cashier-color.png'),
                    link: '/kasir',
                    active: false,
                    sub_menu: [
                      {
                        id: 39,
                        title: 'Kasir Customer',
                        link: '/kasir/customer',
                        icon: require('@/assets/icon/cashier.png'),
                        icon_color: require('@/assets/icon/cashier-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 40,
                        title: 'Kasir Supplier',
                        link: '/kasir/supplier',
                        icon: require('@/assets/icon/cashier.png'),
                        icon_color: require('@/assets/icon/cashier-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 63,
                      //   title: 'Pembukuan Permintaan Barang',
                      //   link: '/kasir/pembukuan',
                      //   icon: require('@/assets/icon/productGrey.png'),
                      //   icon_color: require('@/assets/icon/productBlack.png'),
                      //   active: false,
                      //   sub_menu: [],
                      // }
                    ],
                  },


                  {
                    id: 92,
                    title: 'Tanya Laporan AI',
                    icon: require('@/assets/icon/ai.png'),
                    icon_color: require('@/assets/icon/ai.png'),
                    link: '/laporan-ai',
                    active: false,
                    sub_menu: [],
                  },


                  {
                    id: 80,
                    title: 'WA Gateway',
                    icon: require('@/assets/icon/whatsapp.png'),
                    icon_color: require('@/assets/icon/whatsapp-color.png'),
                    link: '/wa-qr/data',
                    active: false,
                    sub_menu: [],
                  },
                  {
                    id: 89,
                    title: 'Log Activity',
                    icon: require('@/assets/icon/activity-log.png'),
                    icon_color: require('@/assets/icon/activity-log.png'),
                    link: '/audit-trail',
                    active: false,
                    sub_menu: [],
                  },
                  
                  // { aku hide jga di navbar sama tombolnya jga aku hide di hapus datanya list
                  //   id: 101,
                  //   title: 'Hapus Data',
                  //   icon: require('@/assets/icon/delete-file.png'),
                  //   icon_color: require('@/assets/icon/delete-file.png'),
                  //   link: '/hapus-data',
                  //   active: false,
                  //   sub_menu: [
                  //     {
                  //       id: 102,
                  //       title: 'Data BPB',
                  //       link: '/hapus-data/bpb',
                  //       icon: require('@/assets/icon/delete-file.png'),
                  //       icon_color: require('@/assets/icon/delete-file.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //     {
                  //       id: 103,
                  //       title: 'Data Surat Jalan',
                  //       link: '/hapus-data/surat-jalan',
                  //       icon: require('@/assets/icon/delete-file.png'),
                  //       icon_color: require('@/assets/icon/delete-file.png'),
                  //       active: false,
                  //       sub_menu: [],
                  //     },
                  //   ],
                  // },
                  {
                    id: 55,
                    title: 'Pengaturan',
                    icon: require('@/assets/icon/settings-2.png'),
                    icon_color: require('@/assets/icon/settings-color.png'),
                    link: '/master',
                    active: false,
                    sub_menu: [
                      {
                        id: 5,
                        title: 'Cabang',
                        icon: require('@/assets/icon/settings-2.png'),
                        icon_color: require('@/assets/icon/settings-color.png'),
                        link: '/cabang',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 47,
                        title: 'Vehicle',
                        icon: require('@/assets/icon/settings-2.png'),
                        icon_color: require('@/assets/icon/settings-color.png'),
                        link: '/vehicle/data',
                        active: false,
                        sub_menu: [],
                      },
                    {
                        id: 56,
                        title: 'Bank',
                        link: '/master/bank',
                        icon: require('@/assets/icon/settings-2.png'),
                        icon_color: require('@/assets/icon/settings-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 57,
                        title: 'Config',
                        link: '/master/config',
                        icon: require('@/assets/icon/settings-2.png'),
                        icon_color: require('@/assets/icon/settings-color.png'),
                        active: false,
                        sub_menu: [],
                      },
                    ],
                  },

        ],

        form: {
          id: '',
          title: '',
          menu_arr: []
        },

        process: {
          load: false,

          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      // 'form.id': function() {
      //   let t = this

      //   let r = this.role.filter(function(v) {
      //     return t.form.id == v.id
      //   })

      //   if (r.length > 0) {
      //     this.form.title = r[0].name
          
      //     // this.fetchRole()
      //   }
      // }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    beforeMount () {
      // this.fetchRole()
      this.fetch()
    },
    mounted () {
      
    },
    methods: {
      // async fetchRole () {
      //   await get('admin/menu_privilege/data')
      //   .then(response => {
      //     let res = response.data
            
      //     if (res.status === 200) {
      //       this.role = res.results.data

      //       if (this.form.id === '') this.form.id = this.role.length > 0 ? this.role[0].id : ''

      //       if (this.form.id !== '') this.fetch()
      //     }
      //   })
      // },

      async fetch () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        this.form.menu_arr = []

        await get('admin/category_user/data', { params })
        .then(response => {
          let res = response.data

          this.process.laod = false
            
          if (res.status === 200) {
            this.form.id = res.results.data[0].id
            this.form.title = res.results.data[0].title
            let data = res.results.data.length > 0 ? JSON.parse(res.results.data[0].menu_arr) : []
            console.log(data)

            data.map(obj => {
              if (!obj.link.includes('/user') && !obj.link.includes('/sales') && !obj.link.includes('/product') && !obj.link.includes('/customer') && !obj.link.includes('/visit') && !obj.link.includes('/presensi') && !obj.link.includes('/pengajuan') && !obj.link.includes('/finance') && !obj.link.includes('/approval') && !obj.link.includes('/stok') && !obj.link.includes('/delivery') && !obj.link.includes('/kasir') && !obj.link.includes('/promo') && !obj.link.includes('/master') && !obj.link.includes('/pengajuan-barang') && !obj.link.includes('/pembayaran-barang') && !obj.link.includes('/tracking') && !obj.link.includes('/hapus-data')) {
                this.form.menu_arr.push(obj)
              } else {
                if (obj.link.includes('/user')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/sales')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/customer')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/product')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/visit')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/presensi')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/pengajuan')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/finance')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/approval')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/stok')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/delivery')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/kasir')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/promo')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                console.log(obj.link.includes('/master'))
                if (obj.link.includes('/master')) {
                  console.log('test')
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/pengajuan-barang')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/pembayaran-barang')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/tracking')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/hapus-data')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }
              }
            })

            this.form.menu_arr.sort((a, b) => a.id - b.id)
          }
        })
      },

      array_parent () {
        let menu_arr = this.form.menu_arr, menu_fix  = []

        menu_arr.map(obj => {
          if (!obj.link.includes('/user/') && !obj.link.includes('/sales/') && !obj.link.includes('/product/') && !obj.link.includes('/customer') && !obj.link.includes('/visit') && !obj.link.includes('/presensi') && !obj.link.includes('/pengajuan') && !obj.link.includes('/finance') && !obj.link.includes('/approval') && !obj.link.includes('/stok') && !obj.link.includes('/delivery') && !obj.link.includes('/kasir') && !obj.link.includes('/promo') && !obj.link.includes('/master') && !obj.link.includes('/pengajuan-barang') && !obj.link.includes('/pembayaran-barang') && !obj.link.includes('/tracking') && !obj.link.includes('/hapus-data')) {
            menu_fix.push(obj)
          } else {

            if (obj.link.includes('/kasir/')) {
              menu_fix.push({
                id: 38,
                title: 'Kasir',
                icon: require('@/assets/icon/cashier.png'),
                icon_color: require('@/assets/icon/cashier-color.png'),
                link: '/kasir',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/promo/')) {
              menu_fix.push({
                id: 52,
                title: 'Promo',
                icon: require('@/assets/icon/promo.png'),
                icon_color: require('@/assets/icon/promo-color.png'),
                link: '/promo',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/user/')) {
              menu_fix.push({
                id: 1,
                title: 'User',
                icon: require('@/assets/icon/profile.png'),
                icon_color: require('@/assets/icon/profile-color.png'),
                link: '/user',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/sales/')) {
              menu_fix.push({
                id: 10,
                title: 'Sales',
                icon: require('@/assets/icon/sales-manager.png'),
                icon_color: require('@/assets/icon/sales-manager-color.png'),
                link: '/sales',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/customer/')) {
              menu_fix.push({
                id: 6,
                title: 'Customer',
                icon: require('@/assets/icon/target.png'),
                icon_color: require('@/assets/icon/target-color.png'),
                link: '/customer',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/visit/')) {
              menu_fix.push({
                id: 22,
                title: 'Kelola Visit',
                icon: require('@/assets/icon/visitor.png'),
                icon_color: require('@/assets/icon/visitor-color.png'),
                link: '/visit',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/presensi/')) {
              menu_fix.push({
                id: 25,
                title: 'Presensi',
                icon: require('@/assets/icon/absent.png'),
                icon_color: require('@/assets/icon/absent-color.png'),
                link: '/presensi',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/hapus-data/')) {
              menu_fix.push({
                id: 101,
                title: 'Hapus Data',
                icon: require('@/assets/icon/delete-file.png'),
                icon_color: require('@/assets/icon/delete-file.png'),
                link: '/hapus-data',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/pengajuan/')) {
              menu_fix.push({
                id: 28,
                title: 'Pembelian',
                icon: require('@/assets/icon/cash-on-delivery.png'),
                icon_color: require('@/assets/icon/cash-on-delivery-color.png'),
                link: '/pengajuan',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/product/')) {
              menu_fix.push({
                id: 14,
                title: 'Produk',
                icon: require('@/assets/icon/dairy-products.png'),
                icon_color: require('@/assets/icon/dairy-products-color.png'),
                link: '/product',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/finance/')) {
              menu_fix.push({
                id: 33,
                title: 'Finance',
                icon: require('@/assets/icon/report.png'),
                icon_color: require('@/assets/icon/report-color.png'),
                link: '/finance',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/approval/')) {
              menu_fix.push({
                id: 44,
                title: 'Order',
                icon: require('@/assets/icon/order.png'),
                icon_color: require('@/assets/icon/order-color.png'),
                link: '/approval',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/stok/')) {
              menu_fix.push({
                id: 41,
                title: 'Stok',
                icon: require('@/assets/icon/in-stock.png'),
                icon_color: require('@/assets/icon/in-stock-color.png'),
                link: '/stok',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/delivery/')) {
              menu_fix.push({
                id: 48,
                title: 'Pengiriman ',
                icon: require('@/assets/icon/fast-delivery.png'),
                icon_color: require('@/assets/icon/fast-delivery-color.png'),
                link: '/delivery',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/master/')) {
              menu_fix.push({
                id: 55,
                title: 'Pengaturan',
                icon: require('@/assets/icon/settings-2.png'),
                icon_color: require('@/assets/icon/settings-color.png'),
                link: '/master',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/pengajuan-barang/')) {
              menu_fix.push({
                id: 65,
                title: 'Pengajuan Barang',
                icon: require('@/assets/icon/cabangGrey.png'),
                icon_color: require('@/assets/icon/cabangBlack.png'),
                link: '/pengajuan-barang',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/pembayaran-barang/')) {
              menu_fix.push({
                id: 70,
                title: 'Pembayaran Barang',
                icon: require('@/assets/icon/productGrey.png'),
                icon_color: require('@/assets/icon/productBlack.png'),
                link: '/pembayaran-barang',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/tracking/')) {
              menu_fix.push({
                id: 85,
                title: 'Live Tracking',
                icon: require('@/assets/icon/shipment-tracking.png'),
                icon_color: require('@/assets/icon/shipment-tracking-color.png'),
                link: '/tracking',
                active: false,
                sub_menu: []
              })
            } 
          }
        })

        menu_fix = this.array_same(menu_fix)

        return menu_fix
      },
      array_same (arr) {
        let result = arr.reduce((unique, o) => {
            if(!unique.some(obj => obj.id === o.id)) {
              unique.push(o)
            }
            return unique
        },[])

        return result.sort((a, b) => a.id - b.id)
      },
      array_final () {
        let menu_form = this.form.menu_arr, menu_fix = this.array_parent()
        
        menu_form.map(obj => {
          menu_fix.map(obj_sub => {
            if (obj.link.includes('/user/') && obj_sub.link === '/user') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/sales/') && obj_sub.link === '/sales') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/customer/') && obj_sub.link === '/customer') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/visit/') && obj_sub.link === '/visit') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/presensi/') && obj_sub.link === '/presensi') {
              obj_sub.sub_menu.push(obj)
            }

            // if (obj.link.includes('/peta/') && obj_sub.link === '/peta') {
            //   obj_sub.sub_menu.push(obj)
            // }

            if (obj.link.includes('/product/') && obj_sub.link === '/product') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/pengajuan/') && obj_sub.link === '/pengajuan') {
              obj_sub.sub_menu.push(obj)
            }
            
            if (obj.link.includes('/finance/') && obj_sub.link === '/finance') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/approval/') && obj_sub.link === '/approval') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/stok/') && obj_sub.link === '/stok') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/delivery/') && obj_sub.link === '/delivery') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/kasir/') && obj_sub.link === '/kasir') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/promo/') && obj_sub.link === '/promo') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/master/') && obj_sub.link === '/master') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/pengajuan-barang/') && obj_sub.link === '/pengajuan-barang') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/pembayaran-barang/') && obj_sub.link === '/pembayaran-barang') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/tracking/') && obj_sub.link === '/tracking') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/hapus-data/') && obj_sub.link === '/hapus-data') {
              obj_sub.sub_menu.push(obj)
            }
          })
        })

        return menu_fix
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          console.log(this.array_final())

          this.form.menu_arr = JSON.stringify(this.array_final())

          // this.form.menu_arr = JSON.stringify(this.list)

          // SAVE TO REST API
          await post('admin/category_user/update', {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message
              this.$router.push({ path: '/user/category' })

              // this.fetchRole()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>